/**
 * Articles that were unpublished or merged into another, and where their old URLs
 * (often linked from forums) should now go.
 */
export const retiredArticles: Record<string, string> = {
  'beotac-a-tachometer-for-the-beogram-4000-series': '/restoration-services#spindex',
  'updates-to-beotac': '/restoration-services#spindex',
  'servo-motor-replacement-for-the-beogram-4000-series': '/parts/replacement-sledge-motor-for-the-beogram-4000',
  'bg4002-pcb-adapter-for-reservoir-capacitors': '/beogram/400x'
};
